import { Outlet } from 'react-router-dom';

export default function Countries() {
    return (
        <Outlet />
    )
}
